import { SvgIcon, SvgIconProps } from "@mui/material";

export function CircleFalseIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 L11,11 L11,7 L13,7 L13,11 L17,11 L17,13 Z"
        transform="translate(12, 12) rotate(45) translate(-12, -12)"
      ></path>
    </SvgIcon>
  );
}
